import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import { calculatePositions } from 'utils/redux'
import sortedLayoutsSelector from '../selectors/sortedLayouts'
import {
  setPosition
} from '../redux/layouts'

export default function * requestPositionLayout (action) {
  const { id, position } = action.payload

  const state = yield select()

  const layout = state['view-home'].layouts.byId[id]

  if (!layout) throw new Error(`Layout ${id} not found`)

  const layouts = sortedLayoutsSelector(state)

  const positions = calculatePositions({
    array: layouts,
    id,
    position
  })

  const optimisticAction = yield optimisticPut(positions.map(({ id, position }) =>
    setPosition({
      id,
      position
    })
  ))

  try {
    yield call(apiAction, 'PositionMyHomeLayout', {
      homeLayoutId: id,
      position
    })

    yield optimisticAction.commit()
  } catch (e) {
    yield optimisticAction.revert()
  }
}
